import script from "./route-waypoint-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./route-waypoint-popup.vue?vue&type=script&setup=true&lang=js"

import "./route-waypoint-popup.vue?vue&type=style&index=0&id=7dcda7b2&lang=css"
import "./route-waypoint-popup.vue?vue&type=style&index=1&id=7dcda7b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcda7b2"]])

export default __exports__